import { useEffect, useState } from 'react';
import { useFormState } from 'informed';
import { endOfDay } from 'date-fns';
import { useReduxState } from 'hooks';
import { Alert } from 'components/common';

import type { PathStep } from 'shared-types';

interface Props {
  isEditing: boolean;
  initialSettings: Pick<
    PathStep,
    'deadlineDurationUnit' | 'deadlineDurationValue' | 'deadlineType'
  > & { deadlineDate: number };
}

const PathStepsAddOrEditWarning = ({ isEditing, initialSettings }: Props) => {
  const {
    messages,
    pageState: { path }
  } = useReduxState();

  const {
    values: {
      deadlineDate,
      deadlineDurationUnit,
      deadlineDurationValue,
      deadlineType
    }
  } = useFormState();

  const [show, setShow] = useState(false);

  useEffect(() => {
    if (
      !isEditing ||
      !path.numberOfCurrentUsers ||
      path.numberOfCurrentUsers <= 1000
    ) {
      return;
    }

    setShow((show) => {
      const currentSettings = {
        deadlineDate: deadlineDate || null,
        deadlineDurationUnit,
        deadlineDurationValue,
        deadlineType
      };

      const showWarning =
        initialSettings.deadlineType !== currentSettings.deadlineType ||
        (currentSettings.deadlineType !== 'none' &&
          JSON.stringify(initialSettings) !== JSON.stringify(currentSettings));
      return showWarning !== show ? showWarning : show;
    });
  }, [deadlineDate, deadlineDurationUnit, deadlineDurationValue, deadlineType]);

  return show ? (
    <Alert
      style={{ marginTop: 25 }}
      type="warning-light"
      text={messages.pathsWarningLargeAmountOfUsers}
    />
  ) : null;
};

export default PathStepsAddOrEditWarning;
